// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__-m8O30ck","loader":"Loader_loader__icFYjYYg","loaderAnimation":"Loader_loaderAnimation__LYDuqk8d"};